import { render, staticRenderFns } from "./create.vue?vue&type=template&id=5b9208a3&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./create.vue?vue&type=style&index=1&id=5b9208a3&prod&lang=scss&"
import style2 from "./create.vue?vue&type=style&index=2&id=5b9208a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9208a3",
  null
  
)

export default component.exports